import script from "./hero-slider-content.vue?vue&type=script&setup=true&lang=js"
export * from "./hero-slider-content.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__